import { BrowserRouter, Route, Routes } from "react-router";
import "./App.css";
import "./test.css";
import "./responsive.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import './i18n';
// Import End Swiper styles
import Home from "./pages/Home";
import HeaderTop from "./common/Header/HeaderTop";
import HeaderMain from "./common/Header/HeaderMain";
import Sidebar from "./common/Sidebar";
import Footer from "./common/Footer";
import ExchangeInplay from "./pages/ExchangeInplay";
import Lottie from 'lottie-react';
import { useEffect, useRef, useState } from "react";
import { Global } from "./global/Global";
import { GlobalProvider } from "./global/GlobalProvider";
import ChildApp from "./ChildApp";
import config from "./config";
import animationData from './animation.json';

export default function App() {
  const [loading, setLoading] = useState(true);
  const initialized = useRef(false);

  const [theme, setTheme] = useState("dark");

  // useEffect(() => {
  //   if (localStorage.getItem("theme")) {
  //     setTheme(localStorage.getItem("theme"));
  //     document.documentElement.setAttribute("data-theme", localStorage.getItem("theme"));
  //   }
  //   // document.documentElement.setAttribute("data-theme", theme);
  // }, [theme]);

  useEffect(() => {

    const fetchColorCodes = async () => {
      try {
        const hostname = config.WhiteLable;
        if (!initialized.current) {
          initialized.current = true;
        }
        // Update Favicon

        // API Request
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          whiteLabelName: hostname,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/colorCode_world`,
          requestOptions
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const parsedData = await response.json();
        const root = document.documentElement;
        const colorCodes = parsedData.colorCode;
        const lightcolorCodes = parsedData.colorCodeLight;
        localStorage.setItem(
          "logoData",
          JSON.stringify(parsedData.logoSizeData)
        );
        localStorage.setItem("isB2c", JSON.stringify(parsedData.isB2c));
        // localStorage.setItem("isB2c", true);

        // Update CSS variables
        document.title = parsedData.basicDetails.mainName;
        let desc = `Join ${parsedData.basicDetails.mainName} for the best online cricket betting and casino games! Get your exclusive betting ID, enjoy secure transactions, and win big today!`
        let tit = `${parsedData.basicDetails.mainName}: Best Online Cricket & Casino Betting ID`
        const metaDescription = document.querySelector('meta[name="description"]');
        const metaTitle = document.querySelector('meta[name="title"]');
        
        if (metaDescription) {
          metaDescription.setAttribute( "content", desc );
        } else {
          const metaDesc = document.createElement("meta");
          metaDesc.name = "description";
          metaDesc.content = desc;
          document.head.appendChild(metaDesc);
        }

        if (metaTitle) {
          metaTitle.setAttribute( "content", tit );
        } else {
          const titleMeta = document.createElement("meta");
          titleMeta.name = "title";
          titleMeta.content = tit;
          document.head.appendChild(titleMeta);
        }


        localStorage.setItem("logo", parsedData?.basicDetails?.logourl);
        const faviconUrl = parsedData?.basicDetails?.iconurl;
        const faviconElement = document.getElementById("dynamic-favicon");
        if (faviconElement) {
          faviconElement.href = faviconUrl + "?0";
          // debugger
        } else {
          console.warn("Favicon element not found.");
          // debugger
        }

        localStorage.setItem(
          "casinoName",
          parsedData?.basicDetails?.casinoName
        );
        localStorage.setItem("casinoUrl", parsedData?.basicDetails?.gameId);
        localStorage.setItem("mainName", parsedData.basicDetails.mainName);
        localStorage.setItem("adminurl", parsedData.adminurl);
        localStorage.setItem("isHomePageStatus", parsedData.isHomePageStatus);
        localStorage.setItem("pubanner", JSON.stringify(parsedData.pubanner));
        config.isWhiteLabel = parsedData.isHomePageStatus;
        config.pubObj = parsedData.pubanner;
        if (colorCodes && lightcolorCodes) {
          if (config.currentTheme == "dark") {
            root.style.setProperty("--primary-color", colorCodes.color2);
            root.style.setProperty("--home-header-btn-bg", colorCodes.color6_2);
            root.style.setProperty("--home-header-bg", colorCodes.color6_1);
            root.style.setProperty("--bg-sidebar", colorCodes.sidemenu_bg);
            root.style.setProperty("--footer-head-bg", colorCodes.color3);
            root.style.setProperty("--setting-bg", colorCodes.color5);
            root.style.setProperty("--setting-icon-bg", colorCodes.color13);
          } else {
            root.style.setProperty("--setting-icon-bg", lightcolorCodes.color13);
            root.style.setProperty("--setting-bg", lightcolorCodes.color5);
            root.style.setProperty("--primary-color", lightcolorCodes.color2);
            root.style.setProperty(
              "--home-header-btn-bg",
              lightcolorCodes.color6_2
            );
            root.style.setProperty(
              "--home-header-bg",
              lightcolorCodes.color6_1
            );
            root.style.setProperty("--bg-sidebar", lightcolorCodes.sidemenu_bg);
            root.style.setProperty("--footer-head-bg", lightcolorCodes.color3);
          }
        }

        // if (colorCodes.sidemenu_bg) {
        //   root.style.setProperty("--sidemenu-bg", colorCodes.sidemenu_bg);
        // }
        // if (colorCodes.sidemenu_text) {
        //   root.style.setProperty("--sidemenu-text", colorCodes.sidemenu_text);
        // }
        // if (colorCodes.sidemenu_text_hover) {
        //   root.style.setProperty(
        //     "--sidemenu-text-hover",
        //     colorCodes.sidemenu_text_hover
        //   );
        // }
        // if (colorCodes.notification_text) {
        //   root.style.setProperty(
        //     "--notification-text",
        //     colorCodes.notification_text
        //   );
        // }
        // if (colorCodes.betslip_element) {
        //   root.style.setProperty(
        //     "--betslip-elements",
        //     colorCodes.betslip_element
        //   );
        // }
        // root.style.setProperty(
        //   "--header-bg",
        //   `linear-gradient(135deg, ${colorCodes.header_bg1} 0%, ${colorCodes.header_bg2} 100%)`
        // );
        // root.style.setProperty(
        //   "--primary-gradient-hover",
        //   `linear-gradient(135deg, ${colorCodes.color6_1} 0%, ${colorCodes.color6_2} 100%)`
        // );
        // root.style.setProperty(
        //   "--primary-gradient",
        //   `linear-gradient(135deg, ${colorCodes.color1_1} 0%, ${colorCodes.color1_2} 100%)`
        // );
      } catch (error) {
        console.error("Error fetching color codes:", error);

        // Fallback colors in case of error
        const root = document.documentElement;
        // root.style.setProperty("--primary-color", "#ffffff");
        // root.style.setProperty("--primary-light", "#f0f0f0");
        // root.style.setProperty("--light-color", "#d0d0d0");
        // root.style.setProperty(
        //   "--header-bg",
        //   "linear-gradient(135deg, #e0e0e0 0%, #c0c0c0 100%)"
        // );
        // root.style.setProperty(
        //   "--primary-gradient-hover",
        //   "linear-gradient(135deg, #b0b0b0 0%, #909090 100%)"
        // );
        // root.style.setProperty(
        //   "--primary-gradient",
        //   "linear-gradient(135deg, #808080 0%, #606060 100%)"
        // );
      } finally {
        setInterval(() => {
          setLoading(false); // Hide loader
        }, 1000);
      }
    };

    fetchColorCodes();
  }, []);

  return (
    <div className="App">
      <Global>
        <GlobalProvider>
          <BrowserRouter>
            {loading ? <div class="main-loader">
              <Lottie animationData={animationData} loop={true} />
            </div> : <ChildApp />}
          </BrowserRouter>
        </GlobalProvider>
      </Global>
    </div>
  );
}
